import { useTranslation } from 'react-i18next';
import Reveal from '@/components/base/Reveal';
import SectionHeader from '@/components/feature/SectionHeader';

interface Capability {
  title: string;
  desc: string;
}

const ICONS = ['ri-scissors-cut-line', 'ri-focus-3-line', 'ri-layout-row-line', 'ri-tools-line'];

export default function CapabilitiesSection() {
  const { t } = useTranslation();
  const items = t('processing.capabilities.items', { returnObjects: true }) as Capability[];

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <SectionHeader
          eyebrow={t('processing.capabilities.eyebrow')}
          title={t('processing.capabilities.title')}
          subtitle={t('processing.capabilities.subtitle')}
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {items.map((item, index) => (
            <Reveal key={item.title} delay={index * 90}>
              <article className="group flex h-full gap-5 rounded-lg border border-background-200 bg-background-50 p-6 transition-colors duration-300 hover:border-primary-300">
                <span className="flex h-12 w-12 flex-none items-center justify-center rounded-md bg-primary-100 text-2xl text-primary-700 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={ICONS[index % ICONS.length]} />
                </span>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}